import type { ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';

type Props = {
  kicker?: string;
  kickerColor?: string;
  title: ReactNode;
  description?: ReactNode;
  align?: 'left' | 'center';
  actions?: ReactNode;
  className?: string;
};

export function SectionHeader({
  kicker,
  kickerColor,
  title,
  description,
  align = 'left',
  actions,
  className,
}: Props) {
  const isCenter = align === 'center';
  return (
    <div
      className={cn(
        'flex flex-col gap-3 md:flex-row md:items-end md:justify-between',
        isCenter && 'md:flex-col md:items-center md:text-center',
        className,
      )}
    >
      <div className={cn(isCenter && 'mx-auto max-w-2xl')}>
        {kicker && (
          <div
            className="text-[11px] font-semibold uppercase tracking-[0.25em]"
            style={{ color: kickerColor ?? 'var(--color-teal)' }}
          >
            {kicker}
          </div>
        )}
        <h2 className="font-display mt-2 text-3xl font-semibold leading-tight tracking-tight text-balance text-ink md:text-4xl lg:text-5xl">
          {title}
        </h2>
        {description && (
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-ink-dim md:text-base">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
